import { useMemo } from 'react';

export const AI_GENERATED_TAG = 'ai-generated';

export type DatoCmsTagList = readonly (string | undefined)[];

type DatoCmsTags = {
  isAiGenerated: boolean;
};

const normalizeTag = (tag: string) =>
  tag.trim().toLowerCase().replace(/\s+/g, '-');

export const useDatoCmsTags = (tags?: DatoCmsTagList): DatoCmsTags => {
  const isAiGenerated = useMemo(
    () =>
      Boolean(tags?.some(tag => tag && normalizeTag(tag) === AI_GENERATED_TAG)),
    [tags]
  );

  return { isAiGenerated };
};
